import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2, Sun, Wrench, Droplets } from "lucide-react";
import { SERVICES, IMAGES } from "../lib/constants";
import SectionHeading from "../components/SectionHeading";
import SEO from "../components/SEO";

const iconMap = { Sun, Wrench, Droplets };

export default function Servizi() {
  return (
    <div data-testid="page-servizi">
      <SEO
        title="Servizi — Installazione, Manutenzione e Lavaggio Pannelli"
        description="Installazione impianti fotovoltaici civili e industriali, manutenzione programmata, lavaggio professionale pannelli su tetto e a terra. Servizio chiavi in mano in Lombardia."
        path="/servizi"
        image={IMAGES.industrialPlant}
      />
      {/* HERO */}
      <section className="relative h-[50vh] min-h-[380px] flex items-end overflow-hidden">
        <img src={IMAGES.industrialPlant} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 lg:px-12 pb-14 w-full">
          <div className="flex items-center gap-3 mb-4">
            <span className="accent-line" />
            <span className="text-xs uppercase tracking-[0.3em] text-[#FED7AA]">Servizi</span>
          </div>
          <h1 className="font-serif text-white text-4xl md:text-6xl leading-tight max-w-3xl">
            Un servizio completo per il tuo <span className="italic text-[#FED7AA]">fotovoltaico</span>.
          </h1>
        </div>
      </section>

      {/* SERVICES DETAIL */}
      <section className="py-20 md:py-28 bg-[#FAFAFA]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 space-y-20 md:space-y-28">
          {SERVICES.map((s, idx) => {
            const Icon = iconMap[s.icon];
            const reverse = idx % 2 === 1;
            return (
              <article
                key={s.id}
                id={s.id}
                data-testid={`servizio-${s.id}`}
                className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center ${reverse ? "lg:[&>*:first-child]:order-2" : ""}`}
              >
                <div className="lg:col-span-6">
                  <div className="relative">
                    <img
                      src={s.image}
                      alt={s.title}
                      className="rounded-2xl shadow-xl w-full aspect-[4/3] object-cover"
                    />
                    <div className="absolute -bottom-5 -left-5 h-16 w-16 rounded-2xl bg-[#D97706] text-white flex items-center justify-center shadow-xl">
                      <Icon className="h-7 w-7" />
                    </div>
                  </div>
                </div>
                <div className="lg:col-span-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="accent-line" />
                    <span className="text-xs uppercase tracking-[0.25em] text-[#D97706] font-medium">
                      {s.subtitle}
                    </span>
                  </div>
                  <h2 className="font-serif text-3xl md:text-4xl text-[#0F5132] leading-tight">
                    {s.title}
                  </h2>
                  <p className="mt-5 text-[#4B5563] leading-relaxed text-base md:text-lg">
                    {s.description}
                  </p>
                  <ul className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {s.highlights.map((h) => (
                      <li key={h} className="flex items-start gap-2 text-sm text-[#111827]">
                        <CheckCircle2 className="h-5 w-5 text-[#0F5132] mt-0.5 flex-shrink-0" />
                        <span>{h}</span>
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/contatti"
                    data-testid={`servizio-cta-${s.id}`}
                    className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#0F5132] text-white font-medium hover:bg-[#0A3622] transition-all"
                  >
                    Richiedi un preventivo <ArrowRight className="h-4 w-4" />
                  </Link>
                </div>
              </article>
            );
          })}
        </div>
      </section>

      {/* PROCESS */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <SectionHeading
            eyebrow="Il nostro metodo"
            title="Dal primo contatto all'attivazione: come lavoriamo"
          />
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { n: "01", t: "Sopralluogo", d: "Visita tecnica gratuita per valutare tetto, esposizione e consumi reali." },
              { n: "02", t: "Progettazione", d: "Dimensionamento dell'impianto e simulazione della resa annuale attesa." },
              { n: "03", t: "Installazione", d: "Montaggio strutture, posa pannelli, cablaggio e inverter a regola d'arte." },
              { n: "04", t: "Attivazione", d: "Pratiche GSE, allaccio alla rete, monitoraggio e supporto post-vendita." },
            ].map((p) => (
              <div
                key={p.n}
                className="p-7 rounded-2xl border border-[#E5E7EB] bg-[#FAFAFA] hover:shadow-md transition-all"
              >
                <div className="font-serif text-5xl text-[#D97706] mb-4">{p.n}</div>
                <h4 className="font-serif text-xl text-[#0F5132] mb-2">{p.t}</h4>
                <p className="text-sm text-[#4B5563] leading-relaxed">{p.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
